import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgTests = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18.385, height: 18.385, viewBox: "0 0 18.385 18.385", role: "img", ref, ...props, children: /* @__PURE__ */ jsxs("g", { transform: "translate(0 9.192) rotate(-45)", fill: "none", stroke: "currentColor", strokeWidth: 1.6, children: [
  /* @__PURE__ */ jsx("rect", { width: 13, height: 13, stroke: "none" }),
  /* @__PURE__ */ jsx("rect", { x: 0.8, y: 0.8, width: 11.4, height: 11.4, fill: "none" })
] }) });
const ForwardRef = forwardRef(SvgTests);
export default ForwardRef;
